import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function passwordMatchValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password')?.value;
    const repeatPassword = control.get('repeatPassword')?.value;

    return password && repeatPassword && password !== repeatPassword
      ? { passwordMismatch: true }
      : null;
  };
}

export function syncPasswordMismatchError(group: AbstractControl, passwordField = 'password', repeatPasswordField = 'repeatPassword'): void {
  const repeatPassword = group.get(repeatPasswordField);
  if (!repeatPassword) return;

  group.statusChanges.subscribe(() => {
    const hasMismatch = group.errors?.['passwordMismatch'];
    const existingErrors = repeatPassword.errors || {};

    if (hasMismatch) {
      if (!existingErrors['passwordMismatch']) {
        repeatPassword.setErrors({ ...existingErrors, passwordMismatch: true });
      }
    } else {
      if (existingErrors['passwordMismatch']) {
        const { passwordMismatch, ...rest } = existingErrors;
        repeatPassword.setErrors(Object.keys(rest).length ? rest : null);
      }
    }
  });
}
